import { ErrorHandler, Injectable, Injector } from '@angular/core';

import { AppReloadService } from '#services/app-reload/app-reload.service';
import { isChunkLoadError } from '#lib/chunk-load-error';

/**
 * Catches stale bundle failures that reach Angular's global error handling, and hands them to
 * {@link AppReloadService} so the user can be offered a reload.
 *
 * @remarks
 * `AppReloadService` is resolved lazily through the `Injector`. The error handler is
 * constructed before the rest of the application's providers, so injecting it directly would
 * create a cycle.
 *
 * Everything is still passed to the default handler, so no error is swallowed.
 */
@Injectable()
export class StaleBundleErrorHandler extends ErrorHandler {
  constructor(private injector: Injector) {
    super();
  }

  override handleError(error: unknown): void {
    if (isChunkLoadError(error)) {
      this.injector.get(AppReloadService).handleError(error);
    }

    super.handleError(error);
  }
}
